/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import forgotPasswordIMG from '../assets/img/forgot-password.png';
import sawLogo from '../assets/img/saw-logo.png';
import * as auth from '../store/actions/auth.action';
import { isInValidPassword, loginSignUpSuccess } from '../utils/handler';
import { normalizeOTPInput, parseOTP } from '../utils/otp';
import { searchQuery } from './types/signUpAndIntro';

interface formType {
  email: string;
  password: string;
  confirmPassword: string;
}
export const ForgotPassword: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  let history = useHistory();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailForm, setEmailForm] = useState(true);
  const [OTP, setOTP] = useState('');
  const [showBTNLoader, setShowBTNLoader] = useState(false);
  const [OTPSent, setOTPSent] = useState(false);
  const [redirectURL, setRedirectURL] = useState('/');

  const [userDetails, setUserDetails] = useState<formType>({
    confirmPassword: '',
    password: '',
    email: '',
  });
  useEffect(() => {
    let searchObj: searchQuery = history.location.state as searchQuery;
    if (searchObj) {
      setUserDetails({ ...userDetails, email: searchObj.email });
      setRedirectURL(searchObj.returnURL);
    }
  }, [history]);

  const checkFormValid = () => {
    let { password = '', confirmPassword = '' } = userDetails;
    setFormSubmitted(true);
    if (parseOTP(OTP) === undefined) {
      return false;
    } else if (isInValidPassword(password)) {
      return false;
    } else if (password !== confirmPassword) {
      return false;
    }
    return true;
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const normalizedOTP = parseOTP(OTP);
    if (checkFormValid() && normalizedOTP !== undefined) {
      setShowBTNLoader(true);
      let payload = {
        email: userDetails.email,
        OTP: normalizedOTP,
        password: userDetails.password,
        confirmPassword: userDetails.confirmPassword,
      };
      let res = await auth.resetPassword(payload);
      if (res) {
        loginSignUpSuccess(res).then((result) => {
          routeChange();
        });
      }
      setShowBTNLoader(false);
      setFormSubmitted(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserDetails({
      ...userDetails,
      [e.target.name]: e.target.value,
    });
  };
  const forgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (emailForm) {
      setFormSubmitted(true);
    }
    if (userDetails.email) {
      if (emailForm) {
        setShowBTNLoader(true);
      }
      let res = await auth.forgotPassword({email: userDetails.email});
      if (res) {
        toast.success(res);
        setOTPSent(true);
        setEmailForm(false);
      }
      setFormSubmitted(false);
      setShowBTNLoader(false);
    }
  };

  const routeChange = () => {
    history.push(redirectURL);
  };
  return (
    <div className="mx-auto px-md-2 px-lg-4">
      <Helmet>
        <title>Forgot Password - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className="row justify-content-center">
        <div className="col-12 col-lg-11 col-xl-10">
          <div className="card d-flex p-0 pb-3">
            <div className="card-header bb-none">
              <div className="d-flex justify-content-center mt-3 ">
                {' '}
                <img src={sawLogo} className="header-logo" alt="" />{' '}
              </div>
            </div>
            <div className="row px-1">
              <div className="col-md-5 col-sm-12 col-xs-12 c1 d-flex justify-content-center">
                <img src={forgotPasswordIMG} className=" forgot-password-image" alt="Teacher" />
                {/* <div className="row justify-content-center login-welcome-content">
                                    <div className="w-75 mx-md-5 mx-1 mx-sm-2 mb-5 mt-4 px-sm-5 px-md-2 px-xl-1 px-2">
                                        <h1 className="wlcm">{t("Welcome to Saw.com")}</h1> <span className="sp1"> <span className="px-3 bg-danger rounded-pill"></span>
                                            <span className="ml-2 px-1 rounded-circle"></span> <span className="ml-2 px-1 rounded-circle"></span> </span>
                                    </div>
                                </div> */}
              </div>
              <div className="col-md-7 col-sm-12 col-xs-12  mt-5 ">
                <div className="">
                  <span className="font-weight-bold title ">{t('Forgot Password')} </span>
                </div>
                {emailForm ? (
                  <form noValidate className={'justify-content-between mt-2  ' + (formSubmitted ? '  was-validated' : '')} onSubmit={forgotPassword}>
                    <div className="">
                      <label className="mt-2 ">{t('Email')}</label>
                      {/* <div className=" d-flex flex-md-row flex-column justify-content-center align-items-center">
                        <input autoComplete="off" type="email" className="form-control" name="email" value={userDetails.email} onChange={handleChange} placeholder={t('Type Your Email...')} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" required />
                        <button className="btn btn-grad pl-2 mt-3 mt-md-0 " disabled={showBTNLoader} onClick={forgotPassword}>
                          {showBTNLoader ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('Send OTP')}
                        </button>
                        <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                      </div> */}
                      <div className="input-group form-group ">
                        <input autoComplete="off" type="email" className="form-control" name="email" value={userDetails.email} onChange={handleChange} placeholder={t('Type Your Email...')} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" required />

                        <button className="btn-grad btn normal-btn pl-4 pr-4 " disabled={showBTNLoader} onClick={forgotPassword}>
                          {showBTNLoader ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('Send OTP')}
                        </button>
                        <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                      </div>
                      {OTPSent && (
                        <div className="form-row justify-content-end mt-3">
                          <span className=" hover-u" onClick={() => setEmailForm(false)}>
                            {t('Enter OTP?')}
                          </span>
                        </div>
                      )}
                    </div>
                  </form>
                ) : (
                  <form noValidate className={'justify-content-between  mt-2 ' + (formSubmitted ? '  was-validated' : '')} onSubmit={submit}>
                    <div className="form-group">
                      <label className="mt-2 ">{t('Enter your One Time Password sent to your registered email id')}</label>
                      <input
                        autoComplete="off"
                        type="text"
                        inputMode="numeric"
                        className="form-control  "
                        name="OTP"
                        value={OTP}
                        onChange={(e) => setOTP(normalizeOTPInput(e.target.value))}
                        placeholder="Enter your OTP"
                        pattern="[1-9][0-9]{5}"
                        maxLength={6}
                        required
                      />
                      <div className="invalid-feedback">{t('Please Enter OTP')}</div>
                    </div>
                    <div className="form-group">
                      <label className="mt-2 ">{t('Enter your new password')}</label>
                      <div className=" form-group input-group align-items-center password-container">
                        <input
                          autoComplete="off"
                          type={showPassword ? 'text' : 'password'}
                          // onPaste={(e) => { e.preventDefault(); return false }}
                          className="form-control "
                          name="password"
                          value={userDetails.password}
                          onChange={handleChange}
                          placeholder="*******"
                          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                          required
                        />
                        {userDetails.password && <i className={'password-eye fa-lg theme-color c-pointer fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
                        <div className="invalid-feedback">{t('passwordRule')}</div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="mt-2 ">{t('Confirm Password')}</label>
                      <div className="input-group">
                        <input autoComplete="off" type="password" className={'form-control ' + (userDetails.password !== userDetails.confirmPassword ? ' is-invalid' : '')} name="confirmPassword" value={userDetails.confirmPassword} onChange={handleChange} placeholder="*******" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" required />
                        <div className="invalid-feedback">{t('password and confirm password must match')}</div>
                      </div>
                    </div>
                    <div className="form-row justify-content-between pl-2 pr-2">
                      <span className=" hover-u" onClick={() => setEmailForm(true)}>
                        {t('Change Email?')}
                      </span>
                      <span className=" hover-u" onClick={forgotPassword}>
                        {t('Resend OTP?')}
                      </span>
                    </div>
                    <div className="form-row justify-content-center">
                      <button className="btn btn-grad" disabled={showBTNLoader} onClick={submit}>
                        {showBTNLoader ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('SUBMIT')}
                      </button>
                    </div>
                  </form>
                )}
                <div className="justify-content-md-start mt-1 mb-4 d-flex justify-content-center theme-color underline">
                  <span className="hover-u" onClick={() => routeChange()}>
                    {t('Return to Main Page')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
